import { Component } from "@angular/core";
import { ChangeDetectorRef } from '@angular/core';
import { NavController, ModalController, AlertController } from "ionic-angular";
import { IonicPage, NavParams } from "ionic-angular";
import { VariablesProvider } from "../../providers/variables/variables";
import { TrabajadoresPage } from "../trabajadores/trabajadores";
import { ViewController } from "ionic-angular";
import { CalendarioPage } from "../calendario/calendario";
import { LoginPage } from "../login/login";
import { ConfigPage } from "../config/config";
import { FuncionesProvider } from "../../providers/funciones/funciones";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  CalendarModal,
  CalendarModalOptions,
  DayConfig,
  CalendarResult,
} from "ion2-calendar";
import { ToastController } from "ionic-angular";
import { DISABLED } from "@angular/forms/src/model";

@Component({
  selector: "page-vacaciones",
  templateUrl: "vacaciones.html",
})
export class VacacionesPage {

  encontrado = "0";

  diasdefiesta;
  diaIni: Date;
  diaFin: Date;

  myForm: FormGroup;
  myForm1: FormGroup;
  fiestas: Array<{ date: string; subTitle: string }>;
  selectedDay = new Date();
  eventSource;
  viewTitle;
  events;

  misapp: Array<{
    title: string;
    descripcion: string;
    imagen: string;
    component: any;
  }>;

  formulario = { dia1: "", mes1: "", fiesta1: "" };
  resultado;
  date: string;
  type: "string";
  appType = "vacaciones";
  hoyTexto: string = '';


  filtroDias: string = "futuros";
  diasMostrados = [];

  lineasSeleccionadas: any[] = [];
  textoEdicionLineas: string = '';

  tiposVacaciones: any[] = [];
  tipoSeleccionado: any = null;
  tipoSeleccionadoId: any = '';
  resumenTipos: any[] = [];
  
  guardandoTipoInicial: boolean = false;

  optionsRange: CalendarModalOptions = {
    color: "dark",
    weekStart: 1,
    weekdays: ["DO", "LU", "MA", "MI", "JU", "VI", "SA"],
    canBackwardsSelected: true,
    cssClass: "my-day",
    daysConfig: this.variables._daysConfig,
  };

  constructor(
    private cdr: ChangeDetectorRef,
    public fb: FormBuilder,
    public modalCtrl: ModalController,
    public navCtrl: NavController,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    public variables: VariablesProvider,
    public funciones: FuncionesProvider,
    public viewCtrl: ViewController
  ) {

    this.hoyTexto = this.fechaHoyString();

    if (!this.variables.diasOcupados) {
      this.variables.diasOcupados = [];
    }
    
    this.cargarTiposVacaciones();
    
    this.variables.primeravez = "no";
  }



  fechaHoyString(): string {

    let hoy = new Date();
  
    let anio = hoy.getFullYear();
  
    let mes: any = hoy.getMonth() + 1;
    let dia: any = hoy.getDate();
  
    if (mes < 10) {
      mes = '0' + mes;
    }
  
    if (dia < 10) {
      dia = '0' + dia;
    }
  
    return anio + '-' + mes + '-' + dia;
  
  }
  

  ngOnInit() {
    this.filtrarDias();
  }

  getUserTiposVacaciones() {

    let user = this.variables.CLIENTES_RAZSOCIAL;
  
    if (!user || user == '') {
      user = this.variables.emailoriginal;
    }
  
    return user;
  
  }
  

  abrirConfiguracionTipos() {

    this.navCtrl.setRoot(ConfigPage);
  
  }

  mostrarToast(mensaje: string) {

    const toast = this.toastCtrl.create({
      position: "bottom",
      message: mensaje,
      duration: 3000,
    });
  
    toast.present();
  
  }

 

  crearTipoVacacionesPorDefecto() {

    if (this.guardandoTipoInicial) {
      return;
    }
  
    let user = this.getUserTiposVacaciones();
  
    if (!user || user == '') {
      this.mostrarToast('No se pudo detectar la empresa');
      return;
    }
  
    this.guardandoTipoInicial = true;
  
    let datos = {
      id: '',
      user: user,
      codigo: 'VACACIONES',
      nombre: 'Vacaciones',
      dias_anuales: 30,
      ilimitado: 0,
      descuenta_saldo: 1,
      visible_app: 1,
      color: '#111827',
      activo: 1,
      orden: 1
    };
  
    this.funciones.guardarVacacionesTipo(datos).then(
      (respuesta: any) => {
  
        this.guardandoTipoInicial = false;
  
        if (respuesta && respuesta.length > 0 && respuesta[0].RESULTADO == 'ERROR') {
          this.mostrarToast(respuesta[0].MENSAJE);
          return;
        }
  
        this.mostrarToast('Tipo Vacaciones creado con 30 días');
  
        this.cargarTiposVacaciones();
  
      },
      error => {
  
        this.guardandoTipoInicial = false;
  
        console.log(error);
  
        this.mostrarToast('No se pudo crear el tipo Vacaciones');
  
      }
    );
  
  }
  

  cargarTiposVacaciones() {

    this.variables.obtenerVacacionesTipos().then(
      (data: any) => {

        console.log('TIPOS VACACIONES', data);

        if (data && data.length > 0) {

          this.tiposVacaciones = data;

          this.tipoSeleccionado = this.tiposVacaciones[0];
          this.tipoSeleccionadoId = this.tipoSeleccionado.id;

          for (var i = 0; i < this.tiposVacaciones.length; i++) {

            if (this.tiposVacaciones[i].codigo == 'VACACIONES') {
              this.tipoSeleccionado = this.tiposVacaciones[i];
              this.tipoSeleccionadoId = this.tiposVacaciones[i].id;
              break;
            }

          }

        } else {
          this.tiposVacaciones = [];
          this.tipoSeleccionado = null;
          this.tipoSeleccionadoId = '';
        }

        this.obtieneDias();

        this.cdr.detectChanges();

      },
      error => {
        console.log(error);
        this.tiposVacaciones = [];
        this.tipoSeleccionado = null;
        this.tipoSeleccionadoId = '';
        this.resumenTipos = [];
      }
    );

  }

  seleccionarTipoResumen(resumen) {

    if (!resumen) {
      return;
    }

    this.tipoSeleccionadoId = resumen.id;

  }

  getTipoSeleccionado() {

    for (var i = 0; i < this.tiposVacaciones.length; i++) {

      if (this.tiposVacaciones[i].id == this.tipoSeleccionadoId) {
        return this.tiposVacaciones[i];
      }

    }

    return null;

  }

  textoTipo(tipo) {

    if (!tipo) {
      return '';
    }

    if (tipo.ilimitado == 1 || tipo.ilimitado == '1') {
      return tipo.nombre + ' - Ilimitado';
    }

    return tipo.nombre + ' - ' + tipo.dias_anuales + ' días';

  }

  estaSeleccionada(vacas) {

    if (!vacas) {
      return false;
    }
  
    for (var i = 0; i < this.lineasSeleccionadas.length; i++) {
      if (this.lineasSeleccionadas[i] == vacas.ID) {
        return true;
      }
    }
  
    return false;
  
  }

  confirmarLinea(vacas) {

    if (!vacas) {
      return;
    }
  
    if (vacas.ESTADO == "ok") {
      return;
    }
  
    this.variables.DIA = vacas.DIA;
    this.variables.selectedDay = vacas.DIA;
  
    let resultado: any = this.variables.confirmaeldia(
      vacas.TRABAJADOR,
      vacas.DIA
    );
  
    /*
      Si confirmaeldia devuelve Promise, esperamos.
      Si no devuelve Promise, recargamos con un pequeño retardo.
    */
    if (resultado && resultado.then) {
  
      resultado.then((data) => {
        this.mostrarToast('Día confirmado');
        this.obtieneDias();
        this.encontrado = "1";
      });
  
    } else {
  
      setTimeout(() => {
        this.mostrarToast('Día confirmado');
        this.obtieneDias();
        this.encontrado = "1";
      }, 300);
  
    }
  
  }

  imprimirVacaciones() {

    const zona = document.getElementById('zona-vacaciones-imprimir');
  
    if (!zona) {
      alert('No encuentro la zona de vacaciones para imprimir');
      return;
    }
  
    const ventana = window.open('', '_blank', 'width=1000,height=800');
  
    if (!ventana) {
      alert('El navegador ha bloqueado la ventana de impresión');
      return;
    }
  
    let estilos = '';
  
    const links = document.querySelectorAll('link[rel="stylesheet"]');
    for (let i = 0; i < links.length; i++) {
      const link: any = links[i];
      estilos += '<link rel="stylesheet" href="' + link.href + '">';
    }
  
    const styles = document.querySelectorAll('style');
    for (let i = 0; i < styles.length; i++) {
      estilos += '<style>' + styles[i].innerHTML + '</style>';
    }
  
    ventana.document.open();
  
    ventana.document.write(`
      <!doctype html>
      <html>
      <head>
        <meta charset="utf-8">
        <title>Vacaciones</title>
  
        ${estilos}
  
        <style>
          html, body {
            background: #ffffff !important;
            color: #000000 !important;
            font-family: Arial, sans-serif;
            font-size: 12px;
            margin: 0;
            padding: 10px;
            width: 100%;
            height: auto;
            overflow: visible !important;
          }
  
          ion-app,
          ion-content,
          .scroll-content,
          .fixed-content,
          .ion-page {
            position: static !important;
            overflow: visible !important;
            height: auto !important;
            contain: none !important;
            transform: none !important;
          }
  
          ion-header,
          ion-navbar,
          button,
          .no-print,
          ion-calendar.no-print {
            display: none !important;
          }
          table {
            width: 100%;
            border-collapse: collapse;
          }
  
          th, td {
            border: 1px solid #dddddd;
            padding: 5px;
            font-size: 11px;
          }
  
          ion-calendar {
            display: block !important;
            visibility: visible !important;
            opacity: 1 !important;
            height: auto !important;
            overflow: visible !important;
          }
  
          @page {
            size: A4 portrait;
            margin: 10mm;
          }
        </style>
      </head>
  
      <body>
        ${zona.innerHTML}
      </body>
      </html>
    `);
  
    ventana.document.close();
  
    setTimeout(() => {
      ventana.focus();
      ventana.print();
    }, 1200);
  }
  

  limpiarSeleccionLineas() {

    this.lineasSeleccionadas = [];
    this.textoEdicionLineas = '';
  
    if (this.variables.diasOcupados) {
      for (var i = 0; i < this.variables.diasOcupados.length; i++) {
        this.variables.diasOcupados[i].SELECCIONADO = false;
      }
    }
  
    if (this.diasMostrados) {
      for (var j = 0; j < this.diasMostrados.length; j++) {
        this.diasMostrados[j].SELECCIONADO = false;
      }
    }
  
    this.cdr.detectChanges();
  
  }


  obtenerLineaPorId(id) {

    if (!this.variables.diasOcupados) {
      return null;
    }
  
    for (var i = 0; i < this.variables.diasOcupados.length; i++) {
  
      if (this.variables.diasOcupados[i].ID == id) {
        return this.variables.diasOcupados[i];
      }
  
    }
  
    return null;
  
  }

  borrarLineasSeleccionadas() {

    if (!this.lineasSeleccionadas || this.lineasSeleccionadas.length == 0) {
      this.mostrarToast('No hay líneas seleccionadas');
      return;
    }
  
    let total = this.lineasSeleccionadas.length;
    let procesadas = 0;
  
    for (var i = 0; i < this.lineasSeleccionadas.length; i++) {
  
      let id = this.lineasSeleccionadas[i];
      let linea = this.obtenerLineaPorId(id);
  
      if (!linea) {
  
        procesadas++;
  
        if (procesadas >= total) {
          this.lineasSeleccionadas = [];
          this.obtieneDias();
        }
  
      } else {
  
        this.variables.liberarDia(linea.TRABAJADOR, linea.DIA).then(
          (data) => {
  
            procesadas++;
  
            if (procesadas >= total) {
  
              this.mostrarToast('Líneas borradas');
  
              this.lineasSeleccionadas = [];
              this.textoEdicionLineas = '';
  
              this.obtieneDias();
              this.encontrado = "0";
  
            }
  
          },
          error => {
  
            procesadas++;
  
            console.log(error);
  
            if (procesadas >= total) {
              this.lineasSeleccionadas = [];
              this.obtieneDias();
              this.encontrado = "0";
            }
  
          }
        );
  
      }
  
    }
  
  }
  
  aplicarTextoSeleccionadas() {

    if (!this.lineasSeleccionadas || this.lineasSeleccionadas.length == 0) {
      this.mostrarToast('Seleccione una o varias líneas');
      return;
    }
  
    if (!this.textoEdicionLineas || this.textoEdicionLineas.trim() == '') {
      this.mostrarToast('Escriba el texto a aplicar');
      return;
    }
  
    this.actualizarTextoLineas(this.lineasSeleccionadas, this.textoEdicionLineas);
  
  }

  actualizarTextoLineas(ids, texto) {

    if (!ids || ids.length == 0) {
      this.mostrarToast('No hay líneas seleccionadas');
      return;
    }
  
    if (!texto || texto.trim() == '') {
      this.mostrarToast('El texto no puede estar vacío');
      return;
    }
  
    texto = texto.trim();
  
    let total = ids.length;
    let procesadas = 0;
  
    for (var i = 0; i < ids.length; i++) {
  
      let id = ids[i];
  
      this.variables.editadia(id, texto).then(
        (respuesta: any) => {
  
          procesadas++;
  
          if (procesadas >= total) {
  
            if (total == 1) {
              this.mostrarToast('Línea actualizada');
            } else {
              this.mostrarToast('Líneas actualizadas');
            }
  
            this.lineasSeleccionadas = [];
            this.textoEdicionLineas = '';
  
            this.obtieneDias();
  
          }
  
        },
        error => {
  
          procesadas++;
  
          console.log(error);
  
          if (procesadas >= total) {
            this.obtieneDias();
          }
  
        }
      );
  
    }
  
  }


  editarLinea(vacas) {

    if (!vacas) {
      return;
    }
  
    let textoActual = '';
  
    // NOMBRE es el concepto guardado. En registros antiguos podía contener
    // el nombre del trabajador; en ese caso usamos el tipo o Vacaciones.
    textoActual = this.obtenerNombreDia(vacas);
  
    let mensaje = 'Texto que aparecerá en la línea y en el informe.';
  
    if (this.lineasSeleccionadas && this.lineasSeleccionadas.length > 0) {
      mensaje = 'Hay ' + this.lineasSeleccionadas.length + ' líneas marcadas. El texto se aplicará a todas ellas.';
    }
  
    let alert = this.alertCtrl.create({
      title: 'Editar texto',
      message: mensaje,
      inputs: [
        {
          name: 'texto',
          type: 'text',
          value: textoActual,
          placeholder: 'Ej: Enfermo: muñeca mala'
        }
      ],
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel'
        },
        {
          text: 'Guardar',
          handler: data => {
  
            if (!data.texto || data.texto.trim() == '') {
              this.mostrarToast('El texto no puede estar vacío');
              return false;
            }
  
            let idsActualizar = [];
  
            /*
              Si hay líneas seleccionadas, actualizamos todas.
              Si no hay ninguna seleccionada, actualizamos solo esta línea.
            */
            if (this.lineasSeleccionadas && this.lineasSeleccionadas.length > 0) {
  
              for (var i = 0; i < this.lineasSeleccionadas.length; i++) {
                idsActualizar.push(this.lineasSeleccionadas[i]);
              }
  
            } else {
  
              idsActualizar.push(vacas.ID);
  
            }
  
            this.actualizarTextoLineas(idsActualizar, data.texto);
  
          }
        }
      ]
    });
  
    alert.present();
  
  }


  toggleLinea(vacas) {

    if (!vacas) {
      return;
    }
  
    let id = vacas.ID;
  
    let posicion = -1;
  
    for (var i = 0; i < this.lineasSeleccionadas.length; i++) {
  
      if (this.lineasSeleccionadas[i] == id) {
        posicion = i;
        break;
      }
  
    }
  
    /*
      Primero quitamos si ya estaba
    */
    if (posicion >= 0) {
      this.lineasSeleccionadas.splice(posicion, 1);
    }
  
    /*
      Si el checkbox está marcado, lo añadimos
    */
    if (vacas.SELECCIONADO == true) {
      this.lineasSeleccionadas.push(id);
    }
  
  }

  obtenerNombreDia(vacas) {

    if (!vacas) {
      return '';
    }
  
    /*
      Primero mostramos el texto real de la línea.
      Esto es lo que luego saldrá en informes.
    */
    if (vacas.TIPO_NOMBRE && vacas.TIPO_NOMBRE != '') {
      /* El tipo seleccionado es el concepto normal de la línea. */
      if (!vacas.NOMBRE || !vacas.TRABAJADOR_NOMBRE || vacas.NOMBRE == vacas.TRABAJADOR_NOMBRE) {
        return vacas.TIPO_NOMBRE;
      }

      /* Si se editó manualmente el texto, se conserva ese concepto personalizado. */
      return vacas.NOMBRE;
    }

    if (vacas.NOMBRE && vacas.NOMBRE != '' && vacas.TRABAJADOR_NOMBRE && vacas.NOMBRE != vacas.TRABAJADOR_NOMBRE) {
      return vacas.NOMBRE;
    }
  
    return 'Vacaciones';
  
  }

  valorNumero(valor: any): number {

    if (valor === null || valor === undefined || valor === '') {
      return 0;
    }

    let n = Number(valor);

    if (isNaN(n)) {
      return 0;
    }

    return n;

  }

  getCantidadDia(vacas) {

    if (!vacas) {
      return 1;
    }

    if (vacas.CANTIDAD === null || vacas.CANTIDAD === undefined || vacas.CANTIDAD === '') {
      return 1;
    }

    let n = Number(vacas.CANTIDAD);

    if (isNaN(n)) {
      return 1;
    }

    return n;

  }

  calcularResumenTipos() {

    this.resumenTipos = [];
  
    if (!this.tiposVacaciones || this.tiposVacaciones.length == 0) {
      return;
    }
  
    let anioResumen = this.getAnioResumen();
  
    for (var i = 0; i < this.tiposVacaciones.length; i++) {
  
      let tipo = this.tiposVacaciones[i];
  
      let asignados = this.valorNumero(tipo.dias_anuales);
      let gastados = 0;
      let pendientes = 0;
  
      if (this.variables.diasOcupados && this.variables.diasOcupados.length > 0) {
  
        for (var j = 0; j < this.variables.diasOcupados.length; j++) {
  
          let vacas = this.variables.diasOcupados[j];
  
          let anioVacas = this.valorNumero(vacas.ANIO);
  
          if (!anioVacas && vacas.DIA && vacas.DIA.length >= 4) {
            anioVacas = this.valorNumero(vacas.DIA.substr(0, 4));
          }
  
          /*
            Solo contamos días del año actual
          */
          if (anioVacas != anioResumen) {
            continue;
          }
  
          /*
            Solo contamos días de ese tipo
          */
          if (vacas.TIPO_ID == tipo.id) {
  
            if (vacas.ESTADO == 'ok') {
              gastados = gastados + this.getCantidadDia(vacas);
            } else {
              pendientes = pendientes + this.getCantidadDia(vacas);
            }
  
          }
  
        }
  
      }
  
      /*
        Importante:
        Para no pasarnos del límite contamos gastados + pendientes.
      */
      let usados = gastados + pendientes;
  
      let restantes = asignados - usados;
  
  
  
      let ilimitado = 0;
  
      if (tipo.ilimitado == 1 || tipo.ilimitado == '1') {
        ilimitado = 1;
      }
  
      let topeAlcanzado = false;
  
      if (ilimitado != 1 && asignados > 0 && usados >= asignados) {
        topeAlcanzado = true;
      }
  
      this.resumenTipos.push({
        id: tipo.id,
        codigo: tipo.codigo,
        nombre: tipo.nombre,
        asignados: asignados,
        gastados: gastados,
        pendientes: pendientes,
        usados: usados,
        restantes: restantes,
        ilimitado: ilimitado,
        color: tipo.color,
        topeAlcanzado: topeAlcanzado
      });
  
    }
  
  }


  comprobarLimiteTipo(tipo) {

    if (!tipo) {
      return true;
    }
  
    /*
      Si es ilimitado, dejamos crear siempre
    */
    if (tipo.ilimitado == 1 || tipo.ilimitado == '1') {
      return true;
    }
  
    let asignados = this.valorNumero(tipo.dias_anuales);
  
    /*
      Si tiene 0 días y no es ilimitado, no dejamos crear
    */
    if (asignados <= 0) {
      this.mostrarAvisoLimite(tipo.nombre, asignados, 0, 0);
      return false;
    }
  
    let anioResumen = this.getAnioResumen();
  
    let usados = 0;
  
    if (this.variables.diasOcupados && this.variables.diasOcupados.length > 0) {
  
      for (var i = 0; i < this.variables.diasOcupados.length; i++) {
  
        let vacas = this.variables.diasOcupados[i];
  
        let anioVacas = this.valorNumero(vacas.ANIO);
  
        if (!anioVacas && vacas.DIA && vacas.DIA.length >= 4) {
          anioVacas = this.valorNumero(vacas.DIA.substr(0, 4));
        }
  
        if (anioVacas != anioResumen) {
          continue;
        }
  
        if (vacas.TIPO_ID == tipo.id) {
          usados = usados + this.getCantidadDia(vacas);
        }
  
      }
  
    }
  
    let restantes = asignados - usados;
  
    if (restantes <= 0) {
      this.mostrarAvisoLimite(tipo.nombre, asignados, usados, restantes);
      return false;
    }
  
    return true;
  


  }

  mostrarAvisoLimite(nombreTipo, asignados, usados, restantes) {

    let alert = this.alertCtrl.create({
      title: 'Límite alcanzado',
      message:
        'No se pueden añadir más días de "' + nombreTipo + '".<br><br>' +
        'Días asignados: <b>' + asignados + '</b><br>' +
        'Días usados: <b>' + usados + '</b><br>' +
        'Días restantes: <b>0</b>',
      buttons: [
        {
          text: 'Aceptar'
        }
      ]
    });
  
    alert.present();
  
  }


  filtrarDias() {

    if (!this.variables.diasOcupados) {
      this.variables.diasOcupados = [];
    }
  
    let hoy = this.fechaHoyString();
  
    if (this.filtroDias == 'futuros') {
  
      this.diasMostrados = this.variables.diasOcupados.filter(vacas => {
  
        if (!vacas.DIA) {
          return false;
        }
  
        return vacas.DIA >= hoy;
  
      });
  
    } else {
  
      this.diasMostrados = this.variables.diasOcupados;
  
    }
  
    this.diasMostrados.sort(function(a, b) {
  
      if (a.DIA < b.DIA) {
        return -1;
      }
  
      if (a.DIA > b.DIA) {
        return 1;
      }
  
      return 0;
  
    });
  
    this.cdr.detectChanges();
  
  }

  reservarDia() {

    if (this.variables.DIA != null && this.variables.DIA != "") {

      let tipo = this.getTipoSeleccionado();




      if (this.tiposVacaciones.length > 0 && !tipo) {

        const toast = this.toastCtrl.create({
          position: "bottom",
          message: "Seleccione un tipo de día.",
          duration: 3000,
        });

        toast.present();
        return;

      }

  


      if (this.tiposVacaciones.length > 0) {

        this.variables
          .confirmaVacacionesTipo(
            this.variables.IDtrabajador,
            this.variables.DIA,
            this.variables.agosto,
            tipo
          )
          .then((data: any) => {

            if (data && data.length > 0 && data[0].RESULTADO == "ERROR") {

              const toast = this.toastCtrl.create({
                position: "bottom",
                message: data[0].MENSAJE,
                duration: 3000,
              });

              toast.present();
              return;

            }

            this.variables.selectedDay = this.variables.DIA;
            this.obtieneDias();
            this.encontrado = "1";

          });

      } else {

        /*
           Sistema antiguo si no hay tipos creados
        */

        this.variables
          .confirmaVacaciones(
            this.variables.IDtrabajador,
            this.variables.DIA,
            this.variables.agosto
          )
          .then((data) => {

            this.variables.selectedDay = this.variables.DIA;
            this.obtieneDias();
            this.encontrado = "1";

          });

      }

    } else {

      const toast = this.toastCtrl.create({
        position: "bottom",
        message: "Seleccione un día del calendario.",
        duration: 3000,
      });

      toast.present();

    }

  }

  confirmareldia() {

    if (this.variables.DIA != null && this.variables.DIA != "") {

      this.variables.confirmaeldia(
        this.variables.IDtrabajador,
        this.variables.DIA
      );

      let alert2 = this.alertCtrl.create({
        title: "",
        message: "El día " + this.variables.DIA + " ha sido confirmado.",
        cssClass: "alertCustomCss",
        buttons: [
          {
            text: "Aceptar",
            handler: () => {
              this.variables.selectedDay = this.variables.DIA;
              this.obtieneDias();
              this.encontrado = "1";
            },
          },
        ],
      });

      alert2.present();

    } else {

      const toast = this.toastCtrl.create({
        position: "bottom",
        message: "Seleccione un día del calendario.",
        duration: 3000,
      });

      toast.present();

    }

  }

  onChange($event) {

    this.encontrado = "0";

    this.variables.DIA = $event;

    this.variables
      .restodedias(this.variables.IDtrabajador, this.variables.DIA)
      .then((data) => {
        this.diasdefiesta = data;
      });

    if (!this.variables.diasOcupados) {
      this.variables.diasOcupados = [];
    }

    for (var _i = 0; _i < this.variables.diasOcupados.length; _i++) {

      if (this.variables.diasOcupados[_i].DIA == this.variables.DIA) {
        this.encontrado = "1";
        break;
      }

    }

  }

  async borrareldia() {

    if (this.variables.DIA != null && this.variables.DIA != "") {

      let alert = this.alertCtrl.create({
        title: "Liberar día",
        message: "¿Desea liberar el día " + this.variables.DIA + "?",
        cssClass: "alertCustomCss",
        buttons: [
          {
            text: "Aceptar",
            handler: () => {
              this.variables
                .liberarDia(this.variables.IDtrabajador, this.variables.DIA)
                .then((data) => {
                  this.obtieneDias();
                  this.encontrado = "0";
                });
            },
          },
          {
            text: "Cancelar",
            handler: () => {
            },
          },
        ],
      });

      alert.present();

    }

  }

  async borrar(idTrabajador, dia, estado) {

    /*
      Si hay varias líneas marcadas, borramos todas las marcadas.
    */
    if (this.lineasSeleccionadas && this.lineasSeleccionadas.length > 0) {
  
      let alert = this.alertCtrl.create({
        title: "Borrar líneas seleccionadas",
        message:
          "Hay " +
          this.lineasSeleccionadas.length +
          " líneas marcadas.<br><br>¿Desea borrar todas las líneas seleccionadas?",
        cssClass: "alertCustomCss",
        buttons: [
          {
            text: "Cancelar",
            role: "cancel"
          },
          {
            text: "Borrar",
            handler: () => {
              this.borrarLineasSeleccionadas();
            }
          }
        ]
      });
  
      alert.present();
      return;
  
    }
  
    /*
      Si no hay líneas marcadas, borramos solo la línea pulsada.
    */
  
    let titulo = "Liberar día";
    let mensaje = "¿Desea liberar el día?";
  
    if (estado == "ok") {
      titulo = "Liberar día confirmado";
      mensaje = "¿Desea liberar el día que ya está confirmado con el trabajador?";
    }
  
    let alert = this.alertCtrl.create({
      title: titulo,
      message: mensaje,
      cssClass: "alertCustomCss",
      buttons: [
        {
          text: "Aceptar",
          handler: () => {
            this.variables.liberarDia(idTrabajador, dia).then((data) => {
              this.obtieneDias();
              this.encontrado = "0";
            });
          },
        },
        {
          text: "Cancelar",
          role: "cancel"
        },
      ],
    });
  
    alert.present();
  
  }

  async borrarAntiguos(idTrabajador) {

    if (!this.variables.DIA || this.variables.DIA == "") {
  
      const toast = this.toastCtrl.create({
        position: "bottom",
        message: "Seleccione primero un día en el calendario.",
        duration: 3000,
      });
  
      toast.present();
      return;
  
    }
  
    let alert = this.alertCtrl.create({
      title: "Borrar días antiguos",
      message:
        "Se borrarán todos los días anteriores a " +
        this.variables.DIA +
        ".<br><br>El día seleccionado y los posteriores no se borrarán.",
      cssClass: "alertCustomCss",
      buttons: [
        {
          text: "Cancelar",
          role: "cancel"
        },
        {
          text: "Borrar antiguos",
          handler: () => {
  
            this.variables
              .liberarDiasAntiguos(idTrabajador, this.variables.DIA)
              .then((data: any) => {
  
                if (data && data.length > 0 && data[0].RESULTADO == "ERROR") {
  
                  const toast = this.toastCtrl.create({
                    position: "bottom",
                    message: data[0].MENSAJE,
                    duration: 3000,
                  });
  
                  toast.present();
                  return;
  
                }
  
                this.obtieneDias();
                this.encontrado = "0";
  
              });
  
          }
        }
      ]
    });
  
    alert.present();
  
  }


  async borrartodo(idTrabajador, estado) {

    let alert = this.alertCtrl.create({
      title: "Liberar días",
      message: "¿Confirma que desea liberar TODOS los días del trabajador?",
      cssClass: "alertCustomCss",
      buttons: [
        {
          text: "Aceptar",
          handler: () => {
            this.variables.liberarDia(idTrabajador, estado).then((data) => {
              this.obtieneDias();
              this.encontrado = "0";
            });
          },
        },
        {
          text: "Cancelar",
          handler: () => {
          },
        },
      ],
    });

    alert.present();

  }

  irAlDia(diaSeleccionado: string) {

    this.variables.selectedDay = diaSeleccionado;
    this.variables.DIA = diaSeleccionado;

    this.onChange(diaSeleccionado);

  }

  refrescarCalendario() {

    this.optionsRange = {
      color: "dark",
      weekStart: 1,
      weekdays: ["DO", "LU", "MA", "MI", "JU", "VI", "SA"],
      canBackwardsSelected: true,
      cssClass: "my-day",
      daysConfig: this.variables._daysConfig,
    };
  
    this.cdr.detectChanges();
  
  }

  fechaCalendario(dia: string): Date {

    if (!dia) {
      return new Date();
    }
  
    let partes = dia.split('-');
  
    if (partes.length != 3) {
      return new Date(dia);
    }
  
    let anio = Number(partes[0]);
    let mes = Number(partes[1]) - 1;
    let diaMes = Number(partes[2]);
  
    return new Date(anio, mes, diaMes);
  
  }


  getAnioResumen(): number {

    let anio = 0;
  
    if (this.variables.DIA && this.variables.DIA.length >= 4) {
      anio = Number(this.variables.DIA.substr(0, 4));
    }
  
    if ((!anio || anio < 2020) && this.variables.selectedDay && this.variables.selectedDay.length >= 4) {
      anio = Number(this.variables.selectedDay.substr(0, 4));
    }
  
    if (!anio || anio < 2020) {
      anio = new Date().getFullYear();
    }
  
    return anio;
  
  }

  obtieneDias() {

    this.variables.diasOcupados = [];

    this.variables.ndias = 0;

    this.variables._daysConfig = [];

    let promesa: any;

    promesa = this.variables.obtenerVacacionesConTipos(this.variables.IDtrabajador);

    promesa.then((data: any) => {

      if (!data) {
        data = [];
      }

      this.variables.diasOcupados = data;

      for (var s = 0; s < this.variables.diasOcupados.length; s++) {
        this.variables.diasOcupados[s].SELECCIONADO = false;
      }


      for (var _i = 0; _i < this.variables.diasOcupados.length; _i++) {

        /*
           Contador antiguo:
           solo cuenta vacaciones confirmadas.
        */

        if (
          this.variables.diasOcupados[_i].ESTADO == "ok" &&
          (
            this.variables.diasOcupados[_i].TIPO_CODIGO == "VACACIONES" ||
            !this.variables.diasOcupados[_i].TIPO_CODIGO
          )
        ) {
          this.variables.ndias++;
        }
        
        if (this.variables.diasOcupados[_i].ESTADO == "ok") {

          this.variables._daysConfig.push({
            date: this.fechaCalendario(this.variables.diasOcupados[_i].DIA),
            subTitle: "",
            disable: false,
            cssClass: "diareservado",
          });
        
        } else {
        
          this.variables._daysConfig.push({
            date: this.fechaCalendario(this.variables.diasOcupados[_i].DIA),
            subTitle: "",
            disable: false,
            cssClass: "diaOcupado",
          });
        
        }

      }

      this.variables.diasRestantes =
        this.variables.diasVacaciones - this.variables.ndias;

      this.calcularResumenTipos();

      this.filtrarDias();

      this.refrescarCalendario();

    });

  }

  valChange(campo: string, value: string, index: number): void {

    this.variables.editadia(index, value).then(
      (data) => {

        if (data[0].RESULTADO == "ok") {
        } else {
        }

      },
      (err) => {
        console.log(err);
      }
    );

  }

  dismiss() {
    
    if (this.variables.volverDespuesVacaciones) {
      this.navCtrl.setRoot(this.variables.volverDespuesVacaciones);
    } else {
      this.navCtrl.setRoot(TrabajadoresPage);
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/vacaciones/vacaciones.ts